import styled from "styled-components";
// import { ChevronRight } from "@mui/icons-material";
import { Link, useParams } from "react-router-dom";
import colors from "../../theme/colors";
import { useSelector } from "react-redux";
import {
  WarningBanner,
  WarningBannerLink,
} from "../../components/BannerWarning";

import SvgIcon from "@mui/material/SvgIcon";

function HomeIcon(props) {
  return (
    <SvgIcon {...props}>
      <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
    </SvgIcon>
  );
}

function ChevronRight(props) {
  return (
    <SvgIcon {...props}>
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
    </SvgIcon>
  );
}

const ContentArea = styled.div`
  border-bottom: 1px solid #0000001f;
  padding: 10px 10px 10px 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-size: 14px;
  @media (max-width: 700px) {
    padding: 15px 0px;
  }
  @media print {
    display: none !important;
  }
`;

const LinkItem = styled(Link)`
  text-decoration: none;
  color: ${colors.grayDark};
  margin: 0 6px;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 4px;
  &:hover {
    text-decoration: underline;
  }
  @media (max-width: 700px) {
    margin: 0 4px;
  }
`;
const LinkItemContainer = styled.div`
  display: flex;
  align-items: center;
`;

const RenderOrganizationWarning = ({ organizationWarningBanner }) => {
  const organization = useSelector((state) => state.organization);
  const NoUsersWarning = (
    <WarningBanner>
      <p>There are no Users in this Organization.</p>
      <WarningBannerLink to={`${organization?.id}/users`}>
        Add a User
      </WarningBannerLink>
      <p>to get started.</p>
    </WarningBanner>
  );

  const LocationWarning = (
    <WarningBanner>
      <p>There are no Locations in this Organization.</p>
      <WarningBannerLink to={`${organization?.id}/locations`}>
        Add a Location
      </WarningBannerLink>
      <p>to get started.</p>
    </WarningBanner>
  );

  const TanksWarning = (
    <WarningBanner>
      <p>There are no Tanks in this Organization.</p>
      <WarningBannerLink to={`${organization?.id}/tanks`}>
        Add a Tank
      </WarningBannerLink>
      <p>to get started.</p>
    </WarningBanner>
  );

  const OnCallWarning = (
    <WarningBanner>
      <p>On Call has not been set for all Locations in this Organization.</p>
      <WarningBannerLink to={`${organization?.id}/oncall`}>
        Manage On Call
      </WarningBannerLink>
      <p>to get started.</p>
    </WarningBanner>
  );

  switch (organizationWarningBanner.warningType) {
    case "no-users":
      return NoUsersWarning;
    case "no-locations":
      return LocationWarning;
    case "no-tanks":
      return TanksWarning;
    case "no-oncall":
      return OnCallWarning;
    default:
  }
};

const EmergencyBannner = ({ show = false }) => {
  if (show) {
    return (
      <WarningBanner>
        <p>
          We are experiencing rolling cellular outages and are actively working
          to resolve issue. We are temporarily placing select units in
          maintenance mode until resolved.{" "}
          <a
            href="https://boreas.statuspage.io/"
            target="_blank"
            rel="noreferrer"
          >
            View Status
          </a>
        </p>
      </WarningBanner>
    );
  } else return null;
};

const BreadCrumbs = () => {
  const crumbs = useSelector((state) => state.breadCrumbs);
  const {
    isAdminArea,
    isNetworkArea,
    organizationWarningBanner,
    organizationId,
  } = useSelector((state) => state.ux);
  return (
    <>
      <ContentArea>
        {crumbs.map((item, index) => {
          return (
            <LinkItemContainer key={"crumb:" + item.title}>
              {index !== 0 && (
                <ChevronRight sx={{ color: colors.grayDark, fontSize: 16 }} />
              )}
              {isAdminArea || isNetworkArea ? (
                <LinkItem to={item.link}>
                  {index === 0 && (
                    <HomeIcon sx={{ color: colors.grayDark, fontSize: 16 }} />
                  )}
                  {item.title}
                </LinkItem>
              ) : (
                <LinkItem to={`/${organizationId}${item.link}`}>
                  {index === 0 && (
                    <HomeIcon sx={{ color: colors.grayDark, fontSize: 16 }} />
                  )}
                  {item.title}
                </LinkItem>
              )}
            </LinkItemContainer>
          );
        })}
      </ContentArea>
      <EmergencyBannner show={false} />
      {!isAdminArea && !isNetworkArea && (
        <RenderOrganizationWarning
          organizationWarningBanner={organizationWarningBanner}
        />
      )}
    </>
  );
};

export default BreadCrumbs;
